/* SHARED VARS */
var firstrun = true,
    liveEffects = ['fade','scale'],
    liveEasing = 'smooth',
    liveSpeed = 500,
    touch = false,
    list = false,
    clickEv = 'click';

/* SANDBOX */
function mixSandBox(){
  
  // INSTANTIATE MIXITUP ON SANDBOX
  
  if($('#sandBox').length){
    $('#sandBox').mixitup({
      buttonEvent: clickEv,
      onMixStart: function(config){
        
        // PAUSE LOGO ON SANDBOX ACTIVITY
        if(typeof timer != 'undefined'){
          clearInterval(timer);
        };
        if(typeof counter != 'undefined'){
          clearInterval(counter);
        };
        
        // UPDATE EFFECTS LIST
        config.effects = liveEffects;
        
        // UPDATE EASING
        config.easing = liveEasing;
        
        // UPDATE SPEED
        config.transitionSpeed = liveSpeed;
        
        return config;
      },
      onMixEnd: function(config){
        
        // ADD LIST STYING
        var wait = setTimeout(function(){
          if(config.layoutMode == 'list'){
            list = true;
          };
          
          sortSandBox();
        },100);
      }
    });
  }
}

function sortSandBox(){
  var listSB = $('#sandBox .item');
  listSB.removeClass('first');
  $("#sandBox .item:nth-child(4n)").addClass('first');
}

var isMobile = {
  Android: function() {
    return navigator.userAgent.match(/Android/i);
  },
  BlackBerry: function() {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function() {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function() {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function() {
    return navigator.userAgent.match(/IEMobile/i);
  },
  any: function() {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  }
};

/* Fucntion get width browser */
function getWidthBrowser() {
  var myWidth;
  
  if( typeof( window.innerWidth ) == 'number' ) { 
    //Non-IE 
    myWidth = window.innerWidth;
    //myHeight = window.innerHeight; 
  } 
  else if( document.documentElement && ( document.documentElement.clientWidth || document.documentElement.clientHeight ) ) { 
    //IE 6+ in 'standards compliant mode' 
    myWidth = document.documentElement.clientWidth; 
    //myHeight = document.documentElement.clientHeight; 
  } 
    else if( document.body && ( document.body.clientWidth || document.body.clientHeight ) ) { 
      //IE 4 compatible 
      myWidth = document.body.clientWidth; 
      //myHeight = document.body.clientHeight; 
    }
    
    return myWidth;
}

// handles Animate
function dataAnimate(){
  $('[data-animate]').each(function(){
    
    var $toAnimateElement = $(this);
    
    var toAnimateDelay = $(this).attr('data-delay');
    
    var toAnimateDelayTime = 0;
    
    if( toAnimateDelay ) { toAnimateDelayTime = Number( toAnimateDelay ); } else { toAnimateDelayTime = 200; }
    
    if( !$toAnimateElement.hasClass('animated') ) {
      
      $toAnimateElement.addClass('not-animated');
      
      var elementAnimation = $toAnimateElement.attr('data-animate');
      
      $toAnimateElement.appear(function () {
        
        setTimeout(function() {
          $toAnimateElement.removeClass('not-animated').addClass( elementAnimation + ' animated');
        }, toAnimateDelayTime);
        
      },{accX: 0, accY: -80},'easeInCubic');
      
    }
    
  });
}

// Scroll parallax elements
function scrollParallaxElements() {
  if(touch == false){
    $('.parallax').each(function() {
      var $this   = $(this);
      $this.css('background-position', '50% 0px');
    });
  }
}

function callbackSearchMobile(){
  var button = $('.is-mobile .is-mobile-search i');
  var form = $('.is-mobile .is-mobile-search .search-form');
  button.mouseup(function(search) {
    form.show();
  });
  form.mouseup(function() { 
    return false;
  });
  $(this).mouseup(function(search) {
    if(!($(search.target).parent('.is-mobile .is-mobile-search').length > 0)) {
      form.hide();
    }
  });  
}

function handleBoxLogin(){
  $("#loginBox input").focus(function() {
    $(this).parents('#loginBox').addClass('focus');
  }).blur(function() {
    $(this).parents('#loginBox').removeClass('focus');
  });
}

/* Function update scroll product thumbs */
function updateScrollThumbs(){
  if(touch){
    $('#product-image .main-image').on('click', function() {
      var _items = [];
      var _index = 0;
      var product_images = $('#product-image .image-thumb');
      product_images.each(function(key, val) {
        _items.push({'href' : val.href, 'title' : val.title});
        if($(this).hasClass('active')){
          _index = key;
        }
      });
      $.fancybox(_items,{
        closeBtn: true,
        index: _index,
        openEffect: 'none',
        closeEffect: 'none',
        nextEffect: 'none',
        prevEffect: 'none',
        helpers: {
          buttons: {}
        }
      });
      return false;
    });
  }
  else{
    
     }
     
     $('#product').on(clickEv, '.thumb-zoom a', function() {
       
       var $this = $(this);
       var parent = $this.parents('.product-image');
       var child = $this.find('img');
       var src_original = child.attr('data-src-original');
       var src_display = child.attr('data-src-display');
       
       parent.find('.thumb-zoom a').removeClass('active');
       $this.addClass('active');
       
       parent.find('.main-image').find('img').attr('data-zoom-image', src_original);
       parent.find('.main-image').find('img').attr('src', src_display);
       
       return false;
     });
}
    
function handleMenu(){
  // Listener for header
  var scrollTop = $(this).scrollTop();
  var heightHeader = $('#top').outerHeight();
  var heightNav = $('#topnavigation').outerHeight();
  
  if(getWidthBrowser() >= 1024){
    if(scrollTop > heightHeader){
      if(!$('#topnavigation').hasClass('on')){
        $('<div style="min-height:'+heightNav+'px"></div>').insertBefore('#topnavigation');
        $('#topnavigation').addClass('on').addClass('animated');
      }
    }
    else{
      if($('#topnavigation').hasClass('on')){
        $('#topnavigation').prev().remove();
        $('#topnavigation').removeClass('on').removeClass('animated');
      }
    }
  }
}

// Perform operations upon scrolling the window
$(window).scroll(function() {
  // Scroll parallax elements
  scrollParallaxElements();
  
  handleMenu();
});


$(window).resize(function() {
  if(getWidthBrowser() < 1024){
    if($('#topnavigation').hasClass('on')){
      $('#topnavigation').prev().remove();
      $('#topnavigation').removeClass('on').removeClass('animated');
    }
  }
});


jQuery(document).ready(function($) {
  
  /* DETECT PLATFORM */
  $.support.touch = 'ontouchend' in document;
  
  if ($.support.touch) {
    touch = true;
    $('body').addClass('touch');
    clickEv = 'touchstart';
  }
  else{
    $('body').addClass('notouch');
    scrollParallaxElements();
  }

  /* Handle Animate */
  if(touch == false){
    dataAnimate();
  }
  
  handleMenu();
  
  /* Focus Newsletter */
  $("input#email-input").focus(function() {
    $(this).parent().addClass('focus');
  }).blur(function() {
    $(this).parent().removeClass('focus');
  });
  
  // Create contact map
  /* GMap */
  if(jQuery().gMap){
    $('#contact_map').gMap({
      zoom: 17,
      scrollwheel: true,
      maptype: 'ROADMAP',
      markers:[
        {
          address: '249 Ung Văn Khiêm, phường 25, Ho Chi Minh City, Vietnam',
          html: '_address'
        }
      ]
    });
  }
  
  callbackSearchMobile();
  
  //add class if MAC_safari
  if (navigator.appVersion.indexOf("Mac")!=-1){
    if (navigator.userAgent.indexOf("Safari") > -1){
      $('body').addClass('macos');
    }
  }

  $('.dropdown-menu').on(clickEv, function (e) {
    e.stopPropagation();
  });
  $('.dropdown-menu').on('click', function (e) {
    e.stopPropagation();
  });
  $('.btn-navbar').on('click', function() {
    return true;
  });
  $(".dropdown-toggle").parent().hover(function (){
    if(touch == false && getWidthBrowser() > 768 ){
      $(this).find('.dropdown-menu').stop(true, true).slideDown(300);
    }
  }, function (){
    if(touch == false && getWidthBrowser() > 768 ){
      $(this).find('.dropdown-menu').hide();
    }
  });
  $('.dropdown-link').on('click', function() {
     if(touch == false && getWidthBrowser() > 768 ){
       var href = $(this).attr('href');
       window.location = href;
     }
  });
  handleBoxLogin();
  
  $('#collection_tags').on('change', function() {
    window.location = $(this).val();
  });
  
  if($("img.unveil").length){
    $("img.unveil").unveil(300);
  }
  
  /* Product image */
  if(touch){
    updateScrollThumbs();
  }
  else{
    
  }
  
  /* Quantity */
  $('.quantity-wrapper').on(clickEv, '.qty-up', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    $(qty).val(parseInt($(qty).val()) + 1);
  });
  $('.quantity-wrapper').on(clickEv, '.qty-down', function() {
    var $this = $(this);
    
    var qty = $this.data('src');
    
    if(parseInt($(qty).val()) > 1)
    	$(qty).val(parseInt($(qty).val()) - 1);
  });

  
  /* Tooltip */
  $('.btooltip').tooltip();
   
  /* Add class hover for product */
   $('.row-left .hoverBorder').hover( function() {
     $(this).addClass('hover');
   }, function() {
     $(this).removeClass('hover');
   });
  

  /* INSTANTIATE SANDBOX */
  mixSandBox();
  
  /* Sort by */
  $('#sortForm li.sort').click(function(){  // add event any time the sort box changes
    
    var button = $('#sortButton');
    var box = $('#sortBox');
    
    $('#sortButton .name').html($(this).html());
    
    button.removeClass('active');
    box.hide();
  });
  
  sortbyPopup();
  function sortbyPopup(){
    var warper = $('#sortButtonWarper');
    var button = $('#sortButton');
    var box = $('#sortBox');
    var form = $('#sortBox #sortForm');
    warper.click(function(sort) {
      box.toggle();
      button.toggleClass('active');
    });
    form.mouseup(function() { 
      return false;
    });
    $(this).mouseup(function(sort) {
      if(!($(sort.target).parent('#sortButton').length > 0)) {
        button.removeClass('active');
        box.hide();
      }
    });
  }
  
  /* GRID/LIST */
  
  $('#goList').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .mix').addClass('full_width');
    $('#sandBox .mix .row-left').addClass('span4');
    $('#sandBox .mix .row-right').addClass('span8');
    
    $('#sandBox').mixitup('toList');
  });
  
  $('#goGrid').on(clickEv, function(e){
    $(this).parent().find('li').removeClass('active');
    $(this).addClass('active');
    
    $('#sandBox .mix').removeClass('full_width');
    $('#sandBox .mix .row-left').removeClass('span4');
    $('#sandBox .mix .row-right').removeClass('span8');
    
    $('#sandBox').mixitup('toGrid');
  });
});


/* zoom image elevateZoom */
$(window).load(function() {
  if(touch == false){
    
      $("#product-img").elevateZoom({
        scrollZoom : true,
                                    gallery:'gallery_01',     
                                    cursor: 'pointer',
                                    containLensZoom: true,
                                    zoomType:'window',
                                    zoomWindowWidth: 300,
                                    zoomWindowHeight: 400,
                                    galleryActiveClass: 'active',
                                    loadingIcon: '//cdn.shopify.com/s/files/1/0642/3257/t/2/assets/loader.gif?v=147071982126738704471410314215'
                                    });
       
       
       //pass the images to Fancybox
       $("#product-img").bind("click", function(e) {  
         var ez =   $('#product-img').data('elevateZoom');	
         $.fancybox(ez.getGalleryList());
         return false;
       });
        
      

     

      }
});